<div class="container-fluid mat-100">
    <div class="col-lg-12 middle-content-hgt " style="background-color: #f2f2f7;">
        <div class="bb-2 clearfix">
            <div class="col-lg-12 bg-light-blue no-padding">
                <div class="row">
                    <div class="col-12">
                        <h5 class="pull-left pt-2 pl-3 pr-3">All Events</h5>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 " style="padding:20px;">
                <input pInputText type="text" 
                    (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search"
                    style="height: 30px;" />
            </div>
            <div class="col-lg-2">Section Name</div>
            <div class="col-lg-2"><input pInputText type="text" 
                placeholder="Enter section name" [(ngModel)]="sectionname" style="height: 30px;"/></div>
            <div class="col-lg-12" style="margin-top:5px;">
                <p-table #dt [value]="applnList" dataKey="id"
                    [responsive]="true" styleClass="ui-table-customers" [rowHover]="true" [rows]="10"
                    [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" 
                    [paginator]="true" selectionMode="multiple" [scrollable]="true"
                    currentPageReportTemplate="Displaying &#123;first&#125; to &#123;last&#125; of &#123;totalRecords&#125; entries"
                    [filterDelay]="0" [globalFilterFields]="['applnname']">
                    <ng-template pTemplate="header">          
                    <tr>
                        <th pSortableColumn="appId" style="width:20%;text-align:left">AppId
                            <p-sortIcon field="appId">
                            </p-sortIcon>
                        </th>
                        <th pSortableColumn="applnname" style="width:15%;text-align:left">Application Name<p-sortIcon
                            field="applnname">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="applnUrl" style="width:15%;text-align:left">Application Url<p-sortIcon
                        field="applnUrl">
                    </p-sortIcon>
                </th>
                    </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-applnList let-rowIndex="rowIndex">                      
                        <tr class="ui-selectable-row">
                            <td style="width:15%;text-align:left;">
                                <span>{{applnList.appid}}</span>
                             </td>
                            <td style="width:15%;text-align:left;">
                               <span>{{applnList.applnname}}</span>
                            </td>
                            <td style="width:15%;text-align:left;">
                                <span>{{applnList.applnurl}}</span>
                             </td>
                            <td style="width:5%">
                                <label class="container-checkbox">
                                    <input type="checkbox" name="checkbox-list" [(ngModel)]="applnList.selected"
                                        [checked]="applnList.selected === true" ngDefaultControl />
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="12" style="text-align:left">No records found.</td>
                        </tr>
                    </ng-template>
                </p-table>            
                </div>
                    <div class="col-lg-12">
                        <div class="row">
                          <div class="form-group col-md-12" style="text-align: center;">                            
                            <button  class="btn btn-sm btn-info button--primary"  style="min-width:130px">
                              Remove Selection
                            </button>      
                            <button (click)="AddNewSection()" class="btn btn-sm btn-info button--secondary"  style="min-width:100px">
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>  
</div>
</div>